module.exports = __webpack_public_path__ + "img/zongshumei.786bc862.png";